import React from "react";

interface Props {
  svg: string
  alt?: string
  title?: string
  style?: React.CSSProperties
  className?: string
}

const FlagImage = ({ svg, alt, title, style, className }: Props) => {
  return (
    <img
      src={`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`}
      alt={alt}
      title={title}
      style={style}
      className={className} />
  );
};

export default FlagImage;
